import React, {Component} from 'react';
import {ApiClient} from "../../libs/apiClient/ApiClient";
import {ContinueModal, NavBar, Session} from "../../components";
import {DISPATCH_ID, SERVICE_API, SERVICE_RESPONSE, VIEW_NAME, config} from "../../libs/utils/Const";
import moment from "moment";
import {connect} from "react-redux";
import {CSVLink, CSVDownload} from "react-csv";
import $ from 'jquery';
import ExportReportPDFCM from '../../components/ExportReportPDFCM';

let apiClient = ApiClient.getInstance();

class MiddlewareView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            Autorizaciones : [],
            csvData: [],
            Precio : 0,
            txt : 0,
            excel : 0,
            start : 0,
            order : [],
        };
        this.table = null;
        // this.time = null;
        // this.updateTime = this.updateTime.bind(this);
    }

    async componentDidMount(): void {
        //const {enableSpinner} = this.props;
        //enableSpinner(true);
        let fechaInicio = moment(new Date()).format('YYYY-MM-DD');
        let fechaFinal = moment(new Date()).format('YYYY-MM-DD');
        this.setState({
            fechaInicio,
            fechaFinal,
            fechaActual : moment(new Date()).format('YYYY-MM-DD')
        });
        setTimeout(async() => {
            this.cargarDatos();
        }, 400);
        //enableSpinner(false);

        let middlewareResponse = await apiClient.validateMiddleware();
        if(middlewareResponse.status === SERVICE_RESPONSE.ERROR){
            document.getElementById("btnDetener").style.setProperty("opacity",".2");
            document.getElementById("btnIniciar").style.setProperty("opacity","1");
            return;
        }
        document.getElementById("btnIniciar").style.setProperty("opacity",".2");
        document.getElementById("btnDetener").style.setProperty("opacity","1");
    }

    async shouldComponentUpdate(nextProps: Readonly<P>, nextState: Readonly<S>, nextContext: any): boolean{
        // if (this.state.start != nextState.start) {
        //     if(nextState.start == 1){
        //         await this.updateTime(1);
        //     } else {
        //         await this.updateTime(0);
        //     }
        // }      
        setTimeout(async() => {
            let getDocumentsCM = await apiClient.getDocumentsCM();
            if(getDocumentsCM.status !== 0){
                this.setState({
                    txt: getDocumentsCM.data.list.txt > 0 ? 100 / getDocumentsCM.data.list.txt : 100,
                    excel: getDocumentsCM.data.list.excel > 0 ? 100 / getDocumentsCM.data.list.excel : 100
                });
            }
            
        }, 5000);
        
    }

    updateTime = async (parameter) => {
        if(parameter == 1){
            // Ejecuta cada cierto tiempo
            this.time = setInterval(async () => {
                let getDocumentsCM = await apiClient.getDocumentsCM();
                this.setState({
                    txt: getDocumentsCM.data.list.txt > 0 ? 100 / getDocumentsCM.data.list.txt : 100,
                    excel: getDocumentsCM.data.list.excel > 0 ? 100 / getDocumentsCM.data.list.excel : 100
                });
            },1000); 
        } else {
            clearInterval(this.time);
        }
    }

    async cargarDatos (){
        const {enableSpinner} = this.props;
        enableSpinner(true);
        const {fechaInicio, fechaFinal} = this.state;
        let user = localStorage.getItem(config.general.localStorageNamed + 'CurrentUser');
        user = JSON.parse(user) || {};
        //let usuario = user ? user.USERID : '1';
        // console.log('con<<< MIDDLEWARE', user );
        //document.getElementById("commentarios").value = '';
        let data ={
            fechaInicio : fechaInicio,
            fechaFinal : fechaFinal,
        }
        let newdatas = await apiClient.getAutorizacionesCanalModerno(data);
        // let creados = await apiClient.getCreateCanalModerno();
        let precioCanal = await apiClient.getPriceCanalModerno();
        let getDocumentsCM = await apiClient.getDocumentsCM();

        this.setState({
            Autorizaciones: newdatas.data.list,
            usuario : user,
            // DocumentosCreados : creados.data.list,
            Precio : precioCanal.data.list.U_Precio,
            txt: getDocumentsCM.status != 0 && getDocumentsCM.data.list.txt > 0 ? 100 / getDocumentsCM.data.list.txt : 100,
            excel: getDocumentsCM.status != 0 && getDocumentsCM.data.list.excel > 0 ? 100 / getDocumentsCM.data.list.excel : 100
            //hola : newdatas.data
        });

        this.table = $('#canalModerno').DataTable({
            "paging": false,
            "info": false,
            "searching": false
        });
        enableSpinner(false);
    };

    Details = async (valor,Comments) => {
        const {usuario} = this.state;
        // console.log('con< DOCENTRY', valor);
        const {enableSpinner} = this.props;
        enableSpinner(true);
        let data = {
            valor : valor,
            tipo : 'DetailsAutorizationCanalModerno'
        }

        let response = await apiClient.getDatailsAutoCanalModerno(data);
        

        let csvData = [];

        if(response.status === 1){
            // showAlert({type: 'success', message: ' Agregado a carrito correctamente ', timeOut: 0});
            let infoCsv = response.data.body;
            infoCsv.map((item)=>{
                // let precioFinal = item.U_SYP_CCCOMENT - (item.U_SYP_CCCOMENT * (item.U_SYP_NOMEMP / 100));
                let totalsinIgv = (item.U_SYP_CCCOMENT)*(item.Quantity);
                let row ={
                    'Producto': item.ItemName,
                    'EAN': item.ItemCode,
                    'Cantidad': item.Quantity,
                    'Precio': item.Currency+' '+parseFloat(item.U_SYP_CCCOMENT).toFixed(6),
                    'Descuentos': '0 %',// parseFloat(item.U_SYP_NOMEMP).toFixed(2) + ' %',
                    'Precio Final': item.Currency+' '+parseFloat(item.U_SYP_CCCOMENT).toFixed(6),
                    'Total sin IGV': item.Currency+' '+parseFloat(totalsinIgv).toFixed(6), 

                    'Precio Vigente (con descuento) SAP' : item.Currency+' '+parseFloat(item.Price).toFixed(6),
                    'Total sin IGV SAP' : item.Currency+' '+parseFloat(item.LineTotal).toFixed(6),
                    'Dif. de P. Unit': parseFloat(item.Price).toFixed(6) - item.U_SYP_CCCOMENT, //item.StockTxt,
                    'Dif. Total': parseFloat(item.LineTotal-totalsinIgv).toFixed(6),
                    'Info': ' '
                }
                csvData.push(row);
            });

            for (let index = 0; index < 2; index++) {
                const element = csvData[index];
                let row ={
                    'Info': ' '
                }
                csvData.push(row);
            }
            
            let hoy = new Date();
            var Hora = hoy.getHours();
            var Min = hoy.getMinutes();
            var Fecha = hoy.toLocaleDateString();
                
            csvData[0].Info = "RUC "+response.data.body[0].CardCode.substring(1)+"        "+Fecha+"-"+Hora+":"+Min+"hs        ";//+usuario.CardName
            csvData[1].Info = "NRO.SOLICITUD: "+response.data.body[0].DocEntry+" - FECHA : "+response.data.body[0].DocDueDate.substring(0,10);
            csvData[2].Info = "CLIENTE: "+response.data.body[0].CardName+"        EMISIÓN: "+response.data.body[0].DocDate.substring(0,10)+" - F.DESPACHO : "+response.data.body[0].DocDueDate.substring(0,10)+" - O/C : "+response.data.body[0].NumAtCard;

            response = response ? response.data.body : []
                this.setState({
                    order: response,
                    DocEntry : valor,
                    csvData,
                    action : 1
                });
            $('#saveModal').modal('show');
        }

        enableSpinner(false);
        
    };
    
    DetailsOQUT = async (valor,tipo) => {
        const {usuario} = this.state;
        // console.log('con< DOCENTRY', valor, tipo);
        const {enableSpinner} = this.props;
        enableSpinner(true);
        let data = {
            valor : valor,
            tipo : tipo
        }

        let response = await apiClient.getDatailsAutoCanalModerno(data);
        
        let csvData = [];

        if(response.status === 1){
            // showAlert({type: 'success', message: ' Agregado a carrito correctamente ', timeOut: 0});
            let infoCsv = response.data.body;
            infoCsv.map((item)=>{
                let precioFinal = item.U_SYP_CCCOMENT - (item.U_SYP_CCCOMENT * (item.U_SYP_NOMEMP / 100));
                let totalsinIgv = (precioFinal)*(item.Quantity);
                let row ={
                    'Producto': item.ItemName,
                    'EAN': item.ItemCode,
                    'Cantidad': item.Quantity,
                    'Precio': item.Currency+' '+parseFloat(item.U_SYP_CCCOMENT).toFixed(6),
                    'Descuentos': parseFloat(item.U_SYP_NOMEMP).toFixed(6) + ' %',
                    'Precio Final': item.Currency+' '+parseFloat(precioFinal).toFixed(6),
                    'Total sin IGV': item.Currency+' '+parseFloat(totalsinIgv).toFixed(6), 

                    'Precio Vigente (con descuento) SAP' : item.Currency+' '+parseFloat(item.Price).toFixed(6),
                    'Total sin IGV SAP' : item.Currency+' '+parseFloat(item.LineTotal).toFixed(6),
                    'Dif. de P. Unit': precioFinal - parseFloat(item.Price).toFixed(6), //item.StockTxt,
                    'Dif. Total': parseFloat(totalsinIgv-item.LineTotal).toFixed(6)
                }
                csvData.push(row);
            });
            // let hoy = new Date();
            // var Hora = hoy.getHours();
            // var Min = hoy.getMinutes();
            // var Fecha = hoy.toLocaleDateString();
                
            // csvData[0].Info = "RUC "+response.data.body[0].CardCode.substring(1)+"        "+Fecha+"-"+Hora+":"+Min+"hs        "+usuario.CardName;
            // csvData[1].Info = "NRO.SOLICITUD: "+response.data.body[0].id+" - FECHA : "+response.data.body[0].fecha;
            // csvData[2].Info = "CLIENTE: "+response.data.body[0].CardName+"        EMISIÓN: "+response.data.body[0].DocDate.substring(0,10)+" - F.DESPACHO : "+response.data.body[0].DocDueDate.substring(0,10)+" - O/C : "+response.data.body[0].NumAtCard;

            response = response ? response.data.body : []
                this.setState({
                    order: response,
                    DocEntry : valor,
                    csvData,
                    action : 0
                });
            $('#saveModal').modal('show');
        }

        enableSpinner(false);
        
    };

    start = async () =>{
        let middlewareResponse = await apiClient.Middleware(1);
        // this.setState({
        //     start : 1,
        // })
        
        if(middlewareResponse.status === SERVICE_RESPONSE.ERROR){
            return;
        };
        document.getElementById("btnIniciar").style.setProperty("opacity",".2");
        document.getElementById("btnDetener").style.setProperty("opacity","1");

    };

    stop = async () => {
        let middlewareResponse = await apiClient.Middleware(0);
        // this.setState({
        //     start : 0,
        // })
        
        if(middlewareResponse.status === SERVICE_RESPONSE.ERROR){
            return;
        };
        document.getElementById("btnDetener").style.setProperty("opacity",".2");
        document.getElementById("btnIniciar").style.setProperty("opacity","1");
        
    };

    // async handleInputChange (event) {
    //     var archivo = event.target.files[0];
        
    //     if (!archivo) {
    //       return;
    //     }
    //     var lector = new FileReader();
    //     lector.onload = function(e) {
    //       var contenido = e.target.result;
    //       var lineas = contenido.split('\n');

    //       for(var linea of lineas) {
    //         if(linea.substr(0,3) === 'LIN') {
    //         }
    //         if(linea.substr(0,3) === 'PRI') {
    //         }
    //       }
    //       //mostrarContenido(contenido);
    //     };
    //     lector.readAsText(archivo);
    // };

    getData = async () =>{        
        this.table.destroy();
        this.cargarDatos();
    }

    iniciar = async () => {
        $('#continueModal').modal('show');
    }

    handleInputDateInicio = event =>{
        let fechaInicio = event.nativeEvent.target.value;
        this.setState({
            fechaInicio
        });
    }

    handleInputDateFinal = event =>{
        let fechaFinal = event.nativeEvent.target.value;
        this.setState({
            fechaFinal
        });
    }

    render() {
        const {history} = this.props;
        const {Autorizaciones,order,csvData, action, Precio, txt, excel, fechaInicio, fechaFinal, fechaActual} = this.state;//DocumentosCreados
        return (
            <div className="content-fluid" style={{marginTop: 66}}>
                <Session history={history} view={VIEW_NAME.CANALMODERNO_VIEW}/>
                <NavBar/>
                <ContinueModal
                    start = {this.start}
                />
                <div className="container mb-4" style={{paddingTop: 60}}>
                    <div className="row">
                        <div className="col">
                            <div className="jumbotron" style={{paddingTop:'10px', paddingBottom:'10px'}}>
                                <h1 className="display-4 text-center">Canal moderno</h1>
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* style={{paddingTop:'2%',paddingLeft:'5%'}} */}
                    <div align="center" >
                        <button id="btnIniciar"
                                style={{opacity:.1,border: '1px solid gray', width:200, height:200, color:'lightgreen', fontSize: '6em', borderRadius:100, backgroundColor:'white'}}
                                value="iniciar" onClick={()=>this.iniciar()}><i class="fas fa-play"></i></button>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <button id="btnDetener"
                                style={{opacity:.1,border:'1px solid gray', width:200, height:200, color:'red', fontSize:'6em', borderRadius:100, backgroundColor:'white'}}
                                value="detener" onClick={this.stop}><i class="fas fa-stop"></i></button>
                    </div>
                    <div className="col-md-4 col-sm-12" style={{marginLeft:'auto'}}>
                        <div className="col-md-3" align="center" style={{border: '2px solid #000', borderRadius: '10px',marginBottom: '0px', padding : '10px'}}>
                            <h1>S/ {parseFloat(Precio).toFixed(3)}</h1>
                            {/* <button
                                onClick={()=>this.getData()}
                                className="btn botonResumen" 
                                style={{
                                    backgroundColor: config.navBar.menuCategoriesBackgroundHover,
                                    color: config.navBar.textColorCategorieHover,
                                    fontWeight: "bold",
                                }}>
                                Cambiar precio
                            </button> */}
                        </div>
                    </div>
                    <div className="col-md-11 col-sm-12" style={{marginRight:'auto', marginLeft:'auto'}}>
                        <h4>Documento TXT</h4>
                        <div className="progress">    
                            <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style={{width: parseFloat(txt).toFixed(2)+'%'}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{parseFloat(txt).toFixed(2)}%</div>
                        </div>
                    </div>
                    <div className="col-md-11 col-sm-12" style={{marginRight:'auto', marginLeft:'auto'}}>
                        <h4>Documento EXCEL</h4>
                        <div className="progress">    
                            <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style={{width: parseFloat(excel).toFixed(2)+'%'}} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">{parseFloat(excel).toFixed(2)}%</div>
                        </div>
                    </div>
                        
                    <br></br>
                    <br></br>
                    <div className="col-md-12 col-sm-12 text-center"><h3>Documentos para revisar</h3></div>

                    <div className="row text-center" style={{marginBottom: 16, marginTop: 16}}>
                        <div className=" row col-md-4">
                            <h4 className="pr-2">Desde:</h4>
                            <input 
                                id="fechaInicio"
                                type="date" 
                                className="form-control col-md-6" 
                                name="fechauno" 
                                max={fechaActual}
                                value = {fechaInicio}
                                onChange = {(event) => this.handleInputDateInicio(event)}/>
                        </div>
                        <div className="row col-md-4 pb-3">
                            <h4 className="pr-2">Hasta:</h4>
                            <input 
                                id="FechaFin"
                                type="date" 
                                className="form-control col-md-6" 
                                name="fechados" 
                                max={fechaActual}
                                value = {fechaFinal}
                                onChange = {(event) => this.handleInputDateFinal(event)}/>
                        </div>
                        <div className="col-md-2 pb-2">
                            <button
                                onClick={()=>this.getData()}
                                className="btn botonResumen" 
                                style={{
                                    backgroundColor: config.navBar.menuCategoriesBackgroundHover,
                                    color: config.navBar.textColorCategorieHover,
                                    fontWeight: "bold",
                                }}>
                                Listar
                            </button>
                        </div>
                    </div>  

                    {/* <input type="file" name="file" id="file" onChange={this.handleInputChange}  placeholder="Archivo de excel" className="form-control-file" ></input> */}
                    <div className="container col-md-10" >
                        <div className="table-responsive" style={{marginBottom: 0, height: 400, maxHeight: 400 , overflow: 'auto', fontSize:"13px", fontWeight:"bold"}}>
                            <table id="canalModerno" className="table table-hover scrolltable" >
                                <thead >
                                    <tr className="text-light" style={{/*background: '#2d75bd', borderRadius: '0' */}} >
                                        <th >#</th>
                                        {/* <th className="sticky-header"  scope="col">DocNum</th> */}
                                        <th className="text-center" >Cliente</th>
                                        <th className="text-center" scope="col">Nombre cliente</th>
                                        <th className="text-center" scope="col">Canal</th>
                                        <th className="text-center" scope="col">Comentarios</th>
                                        <th className="text-center" scope="col">Fecha</th>
                                        {/* <th className="text-center" scope="col">Total doc.</th>
                                        <th className="text-center" scope="col">Peso total bruto</th>
                                        <th className="text-center" scope="col">Autorización</th> */}
                                        <th className="text-center" scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody style={{overflowY:'auto'}}>
                                    {!!Autorizaciones && Autorizaciones.map((auto, index ) => {
                                            return(
                                                <tr >
                                                    <th >{index+1}</th>
                                                    {/* <td>{auto.DocNum}</td> */}
                                                    <td className="text-center">{auto.CardCode}</td>
                                                    <td className="text-center">{auto.CardName}</td>
                                                    <td className="text-center">{auto.U_SYP_RICO_NCANAL}</td>
                                                    <td className="text-center">{auto.Comments}</td>
                                                    <td className="text-center">{auto.DocDate.substr(0,10)}</td>
                                                    {/* <td className="text-center">S/. {parseFloat(auto.DocTotal).toFixed(2) === '0.00' ? parseFloat(auto.DocTotal2).toFixed(2) : parseFloat(auto.DocTotal).toFixed(2)}</td>
                                                    <td className="text-center">{parseFloat(auto.Weight2).toFixed(2)} KG</td>
                                                    <td className="text-center">{auto.U_Remarks}</td> */}
                                                    <td>
                                                        <button
                                                            className="btn btn-sm"
                                                            type="button"
                                                            // data-toggle="modal" data-target=".bd-example-modal-lg"
                                                            style={{ backgroundColor: config.navBar.iconBackground, color: config.navBar.iconModal }}
                                                            onClick={() => this.Details(auto.DocEntry,auto.Comments)}>
                                                        Ver
                                                        </button>
                                                    </td>
                                                </tr>
                                            )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {/* <br></br>
                    <div className="col-md-12 col-sm-12 text-center"><h3>Documentos creados</h3></div>
                    <div className="container col-md-8 col-sm-12" >
                        <div className="table-responsive" style={{marginBottom: 0, height: 400, maxHeight: 400 , overflow: 'auto', fontSize:"13px", fontWeight:"bold"}}>
                            <table className="table table-hover scrolltable" >
                                <thead >
                                    <tr className="text-light" >
                                        <th >#</th>
                                        <th className="sticky-header"  scope="col">DocNum</th>
                                        <th className="text-center" >Documento</th>
                                        <th className="text-center" scope="col">Oferta de ventas</th>
                                        <th className="text-center" scope="col">Orden de venta</th>
                                        <th className="text-center" scope="col">Notificación</th>
                                    </tr>
                                </thead>
                                <tbody style={{overflowY:'auto'}}>
                                    {!!DocumentosCreados && DocumentosCreados.map((create, index ) => {
                                            return(
                                                <tr >
                                                    <th >{index+1}</th>
                                                    <td className="text-center">{create.doc}</td>
                                                    <td className="text-center">
                                                        <button
                                                            className="btn btn-sm"
                                                            type="button"
                                                            style={{ backgroundColor: config.navBar.iconBackground, color: config.navBar.iconModal }}
                                                            onClick={() => this.DetailsOQUT(create.docEntryOQUT, 'OQUT')}>
                                                        Ver Oferta
                                                        </button>
                                                    </td>
                                                    <td className="text-center">
                                                        <button
                                                            className="btn btn-sm btn-success"
                                                            disabled={create.borrador ===1 ? true : false }
                                                            type="button"
                                                            onClick={() => this.DetailsOQUT(create.docEntryORDR, 'ORDR')}>
                                                        Ver Orden
                                                        </button>
                                                    </td>
                                                    <td className="text-center">{create.autorizacion}</td>
                                                </tr>
                                            )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div> */}

                    <div class="modal fade bd-example-modal-xl" id="saveModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                        <div class="modal-dialog modal-xl">
                            <div className="modal-content">
                                <div className="modal-header text-light" style={{background: '#2d75bd', borderRadius: '0' }}>
                                    <h4 className="modal-title" id="modal-basic-title ">Detalle del documento</h4>

                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span className="text-white" aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <br></br>
                                {/* <div class="row">
                                    <div class="col-sm-12">
                                        <CSVLink
                                        className="btn btn-success float-right"
                                        data={csvData} filename={"Archivo.csv"}>
                                            Descargar orden CSV
                                        </CSVLink>
                                    </div>
                                </div> */}


                            <div className="container col-md-11">
                                <div className="table-responsive" style={{marginBottom: 0, height: 600, maxHeight: 600 , overflow: 'auto', fontSize:"13px", fontWeight:"bold"}}>
                                    <table className="table table-hover scrolltable" >
                                        <thead >
                                            <tr className="text-light" style={{/*background: '#2d75bd', borderRadius: '0' */}} >
                                                <th>#</th>
                                                {/* <th className="sticky-header"  scope="col">DocNum</th> */}
                                                <th className="text-center" >Artículo</th>
                                                <th className="text-center" scope="col">Código</th>
                                                <th className="text-center" scope="col">Cantidad</th>
                                                <th className="text-center" scope="col">Precio</th>
                                                <th className="text-center" scope="col">Total</th>
                                                <th className="text-center" scope="col">Total CEN</th>
                                                {/* <th className="text-center" scope="col">Total doc.</th>
                                                <th className="text-center" scope="col">Peso total bruto</th>
                                                <th className="text-center" scope="col">Autorización</th> */}
                                            </tr>
                                        </thead>
                                        <tbody style={{overflowY:'auto'}}>
                                            {!!order && order.map((item, index ) => {
                                                    return(
                                                        <tr style={{background: Number(item.LineTotal) !== Number(item.U_RNT_CEN_TOTALIN) ? 'red' : '', color: Number(item.LineTotal) !== Number(item.U_RNT_CEN_TOTALIN) ? 'white' : 'black'}}>
                                                            <th >{index+1}</th>
                                                            {/* <td>{auto.DocNum}</td> */}
                                                            <td className="text-left">{item.ItemName}</td>
                                                            <td className="text-center">{item.ItemCode}</td>
                                                            <td className="text-center">{parseInt(item.Quantity)}</td>
                                                            <td className="text-center">{item.Currency+' '+parseFloat(item.Price).toFixed(2)}</td>
                                                            <td className="text-center">{item.Currency+' '+parseFloat(item.LineTotal).toFixed(2)}</td>
                                                            <td className="text-center">{item.Currency+' '+parseFloat(item.U_RNT_CEN_TOTALIN || 0).toFixed(4)}</td>
                                                            {/* <td className="text-center">S/. {parseFloat(auto.DocTotal).toFixed(2) === '0.00' ? parseFloat(auto.DocTotal2).toFixed(2) : parseFloat(auto.DocTotal).toFixed(2)}</td>
                                                            <td className="text-center">{parseFloat(auto.Weight2).toFixed(2)} KG</td>
                                                            <td className="text-center">{auto.U_Remarks}</td> */}
                                                        </tr>
                                                    )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                                <div className="modal-footer justify-content-right">
                                {/* {editar ?
                                    <button type="button" className="btn btn-success" style={{display:Tipo === 'W' ? 'block' : 'none' }} onClick={()=> this.addToShopingCart()}>
                                        <i className="fas fa-cart-plus"/>
                                        &nbsp; Editar
                                    </button>
                                    :
                                    ''
                                } */}

                                <CSVLink
                                    className="btn btn-success float-right"
                                    style={{display:action === 1 ? 'block' : 'none' }}
                                    data={csvData} filename={"CanalModerno.csv"}>
                                        Descargar Excel <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                                </CSVLink>
                                <ExportReportPDFCM data={order}></ExportReportPDFCM>
                                {/* <button type="button" class="btn btn-danger float-right" style={{display:Tipo === 'W' ? 'block' : 'none' }} disabled={Tipo === 'W' ? false : true} data-toggle="modal" data-target=".comentarios" >Rechazar</button>
                                <button type="button" class="btn btn-success float-right" style={{display:Tipo === 'W' ? 'block' : 'none' }} disabled={Tipo === 'W' ? false : true} onClick={this.Autorizar}>Autorizar</button> */}

                            </div>
                            </div>
                        </div>
                    </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        sessionReducer: store.SessionReducer,
        configReducer: store.ConfigReducer,
        notificationReducer: store.NotificationReducer,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({type: DISPATCH_ID.CONFIG_SET_SPINNER, value}),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MiddlewareView);